import React, { useCallback, useEffect } from "react";
import styles from "./ZoomHandler.module.css";
import { CustomIconButton, icon } from "../../../../../../../common/components";
import { ZOOM_MAX, ZOOM_MIN, ZOOM_STEP } from "../../../../../constants/constants";

const PADDING_OFFSET = 48;

function getZoom(imageWidth, pdfContainerWidth) {
	const currentZoom = Math.floor((pdfContainerWidth / imageWidth) * 10) * 10;
	if (currentZoom < ZOOM_MIN) {
		return ZOOM_MIN;
	}
	if (currentZoom > ZOOM_MAX) {
		return ZOOM_MAX;
	}
	return currentZoom;
}

const ZoomHandler = ({ documentId, pageDimensions, pdfContainerWidth, zoom, onZoomChange }) => {
	const initZoom = useCallback(() => {
		if (Array.isArray(pageDimensions) && pageDimensions.length && pdfContainerWidth) {
			const maxWidth = Math.max(...pageDimensions.map((o) => o.width));
			if (maxWidth > 0) {
				onZoomChange(getZoom(maxWidth, pdfContainerWidth - PADDING_OFFSET));
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pageDimensions, pdfContainerWidth]);

	useEffect(() => {
		if (documentId && !zoom) {
			initZoom();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [documentId, pageDimensions, pdfContainerWidth]);

	const handleZoomOut = () => {
		if (zoom > ZOOM_MIN) {
			onZoomChange(zoom - ZOOM_STEP);
		}
	};
	const handleZoomIn = () => {
		if (zoom < ZOOM_MAX) {
			onZoomChange(zoom + ZOOM_STEP);
		}
	};

	return (
		<div className={styles.zoom}>
			{documentId && (
				<>
					<CustomIconButton
						disabled={zoom <= ZOOM_MIN}
						icon={icon.aitSearchMinus}
						iconClassName={styles.zoom__btn}
						iconColor="var(--grey-800)"
						size="xs"
						onClick={handleZoomOut}
					/>
					<div>{zoom}%</div>
					<CustomIconButton
						disabled={zoom >= ZOOM_MAX}
						icon={icon.aitSearchPlus}
						iconClassName={styles.zoom__btn}
						iconColor="var(--grey-800)"
						size="xs"
						onClick={handleZoomIn}
					/>
				</>
			)}
		</div>
	);
};

export default ZoomHandler;
